import React from 'react';
import {Link} from "react-router-dom";
import ScrollAnimation from "react-animate-on-scroll";

const ServiceList = [

    {
        image: "./images/service/img web panini-03.png",
        title: 'Contrata a los mejores',
        link:'/#busquedapersonal',
        description: 'Búsqueda personal'
    },
    {
        image: "./images/service/img web panini-04.png",
        title: "Entrenalos",
        link:'/#Gastromentorias',
        description: 'Gastromentorias'
       
    },
    {
        image: "./images/service/img web panini-05.png",
        title: 'Monitorealos',
        link:'/#mystery',
        description: 'Mystery shopper'
        
    }

]
const ServiceThree = ({textAlign, serviceStyle}) => {
    return (
        <div className="row row--15 service-wrapper">
              {ServiceList.map( (val , i) => (
                <div className="col-lg-4 col-md-4 col-sm-4 col-12" key={i}>
                        <div className={`service ${serviceStyle} ${textAlign}`}>
                            <div className="inner">
                            <a href={`${val.link}`}>
                                <div className="image">
                                    <img src={`${val.image}`} alt="card Images" loading="lazy" />
                                </div>
                                </a>
                                <div className="content">
                                    <h4 className="title2"><a href={`${val.link}`} dangerouslySetInnerHTML={{__html: val.title}}></a></h4>
                                    <h6 className="descripcion2" dangerouslySetInnerHTML={{__html: val.description}}></h6> 
                                </div>
                            </div>
                        </div>
                   
                </div>
            ))}
        </div>
    )
}
export default ServiceThree;